import {
  columnResizingFeature,
  columnSizingFeature,
  columnVisibilityFeature,
  createColumnHelper,
  createPaginatedRowModel,
  createSortedRowModel,
  rowPaginationFeature,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_alphanumericCaseSensitive,
  sortFn_basic,
  sortFn_datetime,
  sortFn_text,
  sortFn_textCaseSensitive,
  tableFeatures,
} from "@tanstack/react-table";
import type { RowData } from "@tanstack/react-table";

/**
 * Shared TanStack Table v9 feature set for Sellar tables.
 *
 * Intentionally minimal (not `stockFeatures`): only the features column defs
 * and shared table hooks actually use — sorting, pagination, visibility, and
 * sizing/resizing. Client row models and individual sort fns are registered
 * for tree-shaking; tables that process server-side should set
 * `manualSorting` / `manualPagination`.
 */
export const sellarTableFeatures = tableFeatures({
  rowSortingFeature,
  rowPaginationFeature,
  columnVisibilityFeature,
  columnSizingFeature,
  columnResizingFeature,
  sortedRowModel: createSortedRowModel(),
  paginatedRowModel: createPaginatedRowModel(),
  sortFns: {
    alphanumeric: sortFn_alphanumeric,
    alphanumericCaseSensitive: sortFn_alphanumericCaseSensitive,
    basic: sortFn_basic,
    datetime: sortFn_datetime,
    text: sortFn_text,
    textCaseSensitive: sortFn_textCaseSensitive,
  },
});

export type SellarTableFeatures = typeof sellarTableFeatures;

/** Column helper pre-bound to {@link sellarTableFeatures}. */
export function createSellarColumnHelper<TData extends RowData>() {
  return createColumnHelper<SellarTableFeatures, TData>();
}
